<template>

<Layout>
   <div class="container">
        <div class="header">
          <h2>Produtos</h2>
          <hr>
        </div>
        <div class="main">
          <div>
             <Table />
           </div>
        </div>
        <div class="footer"></div>
      </div>
</Layout>

</template>
<script>

import ButtonAdd from "../../components/Button/Button_M1.vue";
import Layout from "../Layout/Layout.vue";
import Table from "./modules/Checklist.vue"

export default {
  components: {
    Layout,
    Table,
    ButtonAdd,
 
  },
  data(){
    return{
    modalView : false,
    }
  },
  methods : {
    click_vmodal(){
   this.modalView = !this.modalView
    }
  }
  
  }

</script>

<style>

.header h2{

  font-size: 1.5vw;
}
.container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}


@media (max-width: 692px){

.header h2{

  font-size: 3.5vw;
}

.main {
  
    width: 100%;
    height: 100%;
    margin-left: 0px;
    padding: 20px;
    transition: 0.5s;
}

}

</style>